import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loginingOut } from "../features/userSlice";
import { auth } from "../firebase/config";
import { signOut } from "firebase/auth";

export const useLogout = () => {
  const [error, setError] = useState(null);
  const [isCancelled, setIsCancelled] = useState(false);
  const dispatch = useDispatch();

  const logout = async () => {
    setError(null);
    try {
      await signOut(auth);

      if (!isCancelled) {
        dispatch(loginingOut());
      }
    } catch (err) {
      if (!isCancelled) {
        console.log(err.message);
        setError(err.message);
      }
    }
  };

  useEffect(() => {
    return () => setIsCancelled(true); // Cleanup function to prevent updates on unmounted components
  }, []);

  return { error, logout };
};
